import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCompany(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M11.375 2.22a1 1 0 0 1 1.25 0l7.5 6a1 1 0 0 1 0 1.56l-7.5 6a1 1 0 0 1-1.25 0l-7.5-6a1 1 0 0 1 0-1.56l7.5-6ZM6.101 9 12 4.28 17.898 9 12 13.72 6.1 9Z"
        fill="currentColor"
      />
      <path
        d="M5.125 13.22a1 1 0 1 0-1.25 1.56l7.5 6a1 1 0 0 0 1.25 0l7.5-6a1 1 0 1 0-1.25-1.56L12 18.72l-6.875-5.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
